import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Link, useLocation, useNavigate } from "react-router";
import PaymentForm from "../accountSettings/payment-methods/paymentFormNew";
import styles from "../../../styles/paymentBlock.module.scss";
import SuccessPayment from "./SuccessPayment";
import { URLS } from "../../../utility/constants/appConstants";

const PaymentBlock = ({ paymentDataProp, handleDataSubmit, hasSelection, flag }) => {
  const [paymentData, setPaymentData] = useState(paymentDataProp);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);

  const payIframeRef = useRef(null);

  const nav = useNavigate();
  const loc = useLocation();

  const handleSubmit =  async(e, body="") => {
    
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    if (e && typeof e.stopPropagation === "function") e.stopPropagation();

    const selectionBoxCheck = JSON.parse(sessionStorage.getItem("paymentlist"));

    if (selectedMethod === "") {
      return;
    }

    const isValid = selectionBoxCheck[0].listData.length || selectedMethod === "";

    if (!isValid) {
      return;
    }

    if (selectedMethod) {
      const selected = paymentDataProp.find(
        (m) => m.pccTokenNum === selectedMethod
      );
      const methodText =
        selectedMethod === "new"
          ?(body.isAccount && !body.isCreditCard ? `BankAccount ending in${body.tokenNum.slice(-4)}`: `${body.cashSubType} ending in ${body.tokenNum.slice(-4)}`)
          : `${selected?.pccPaymentType} ending in ${selected?.pccAcctLast4}`;

      const bodyData = body === "" ? selected : body;
      
      if (typeof handleDataSubmit === "function") {
        try {
          const confirmationNumber = await handleDataSubmit(bodyData, selectedMethod === "new" ? true : false);
          
          if(confirmationNumber === undefined) return;

          setSuccessMessage({
            method: methodText,
            confirmation: confirmationNumber,
            data: {
            pccAcctLast4:  body.isAccount? body.tokenNum.slice(-4)  :  (selected?.pccAcctLast4 || body['Card Number'].slice(-4)),
            pccCashType:body.isAccount ? "CHK":(selected?.pccCashType || body.cashSubType),
            pccCashSubType:body.isAccount ? 'CHK':(selected?.pccCashSubType || body.cashSubType),
            cardType:body.isAccount? 'CHK':  body['Card Type'],
            }
          });

          let checkedData = sessionStorage.getItem("paymentlist");
          let parseList = JSON.parse(checkedData);
          parseList[0].successData = {
            method: methodText,
            confirmation: confirmationNumber?.data ? confirmationNumber?.data?.ConfirmationNumber : confirmationNumber,
            data: {
            pccAcctLast4:  body.isAccount? body.tokenNum.slice(-4)  :  (selected?.pccAcctLast4 || body['Card Number'].slice(-4)),
            pccCashType:body.isAccount ? "CHK":(selected?.pccCashType || body.cashSubType),
            pccCashSubType:body.isAccount ? 'CHK':(selected?.pccCashSubType || body.cashSubType),
            cardType:body.isAccount? 'CHK':  body['Card Type'],
            }
          };
          
          sessionStorage.setItem("paymentlist", JSON.stringify(parseList));
        
        
          if (loc.pathname === "/my-account/payments/prepay-payment") {
            nav("/my-account/payments/one-time-payment");
          } else if (loc.pathname.includes("/my-account/payments/easypay-payment")) {
            nav("/my-account/payments/easypay-success-payment");
          } else {
            nav("/my-account/account-settings/easypay-settings/update-easypay-success");
          }
        } catch (error) {
          return error;
        }

      }
    } else {
      setSuccessMessage(null);
    }
  };

  return (
    <div className="mb-40 row">
      <>
        <div className="col-12">
          <div className={`${styles["mb-10"]} row`}>
            <div className="col-12">
              <span className={`${styles["gfs-24"]} ${styles["gfw-3"]}`}>
                Choose a payment method
              </span>
            </div>
          </div>
        </div>
        <form onSubmit={(e) => handleSubmit(e)} className="col-12">
          {paymentDataProp.map((method, index) => (
            <div
              className={`row ${styles["mb-16"]} ${styles["tru-mma-main-add"]}`}
              key={method.pccSid || index}
            >
              <div
                className={`align-items-center gap-3 col-12 d-flex ${styles["p-16"]}`}
              >
                <div>
                  <input
                    type="radio"
                    name="paymentMethod"
                    value={method.pccTokenNum}
                    checked={selectedMethod === method.pccTokenNum}
                    onChange={(e) => setSelectedMethod(e.target.value)}
                    className={`${styles["radio"]} mr-10`}
                    id={`payment-method-${index}`}
                  />
                </div>
                <label
                  className={`${styles["gfs-24"]} ${styles["gfw-3"]} ${styles["glh-1"]} ${styles["m-0"]}`}
                  htmlFor={`payment-method-${index}`}
                >
                  {method.pccPaymentType} ending in {method.pccAcctLast4}
                </label>
              </div>
            </div>
          ))}

          <div
            className={`row ${styles["mb-16"]} ${styles["tru-mma-main-add"]}`}
          >
            <div
              className={`align-items-center gap-2 col-12 d-flex ${styles["p-16"]}`}
            >
              <div>
                <input
                  type="radio"
                  name="paymentMethod"
                  value="new"
                  className={`${styles["radio"]} ${styles["mr-10"]}`}
                  checked={selectedMethod === "new"}
                  onChange={(e) => setSelectedMethod(e.target.value)}
                  id="payment-method-new"
                />
              </div>
              <label
                className={`${styles["gfs-24"]} ${styles["gfw-3"]} ${styles["glh-1"]} ${styles["m-0"]}`}
                htmlFor="payment-method-new"
              >
                New payment method (Debit/Credit card or Bank account)
              </label>
            </div>
          </div>
          {selectedMethod === "new" && (
            <div className="row">
              <div className="col-12 p-0">
                <PaymentForm ref={payIframeRef} onSubmit={handleSubmit} flag={flag} />
              </div>
            </div>
          )}

          {selectedMethod !== "new" && (
            <div className="row">
              <div className="col-12 p-0">
                <div className="justify-content-end row">
                  <div className="col-12 col-md-6 col-lg-4 text-right">
                    <Link
                      to={URLS.easyPaySettings}
                      className={`btn ${styles["btn-gray-light"]} ${styles["btn-lg"]} ${styles["mb-20"]} ${styles["mb-md-0"]} ${styles["text-white"]} ${styles["w-100"]}`}
                    >
                      Cancel
                    </Link>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 text-right">
                    <button
                      type="submit"
                      className={`btn ${styles["btn-lg"]} ${
                        styles["btn-primary"]
                      } ${styles["w-100"]} ${
                        selectedMethod === "" || !hasSelection
                          ? styles["btn-disabled"]
                          : ""
                      }`}
                      disabled={selectedMethod === "" || !hasSelection}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </form>
      </>
    </div>
  );
};

export default PaymentBlock;